import { ChainId } from '@pancakeswap/chains'
import { useTranslation } from '@pancakeswap/localization'
import {
  ArrowDownIcon,
  ArrowUpIcon,
  Box,
  Button,
  Flex,
  InfoIcon,
  Text,
  UserMenu,
  UserMenuDivider,
  UserMenuItem,
  useTooltip,
} from '@pancakeswap/uikit'
import Acount from 'components/Menu/UserMenu'
import { ASSET_CDN } from 'config/constants/endpoints'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { useNetworkConnectorUpdater } from 'hooks/useActiveWeb3React'
import { useHover } from 'hooks/useHover'
import { useSessionChainId } from 'hooks/useSessionChainId'
import { useSwitchNetwork } from 'hooks/useSwitchNetwork'
import { useRouter } from 'next/router'
import { chains } from 'utils/wagmi'
import { useNetwork } from 'wagmi'

import { ChainLogo } from './Logo/ChainLogo'

const WHITELIST_CHAIN = [1975, 137, 56]
// const WHITELIST_CHAIN = [1975, 137]

const NetworkSelect = ({ switchNetwork, chainId }) => {
  const { t } = useTranslation()
  return (
    <>
      <Box px="16px" py="8px">
        <Text>{t('Select a Network')}</Text>
      </Box>
      <UserMenuDivider />
      {chains
        .filter((chain) => {
          if (chain.id === chainId) return true
          if ('testnet' in chain && chain.testnet) {
            return process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production'
          }
          return true
        })
        .map((chain) => (
          <UserMenuItem
            disabled={!WHITELIST_CHAIN.includes(chain.id)}
            key={chain.id}
            style={{
              justifyContent: 'flex-start',
              cursor: WHITELIST_CHAIN.includes(chain.id) ? 'pointer' : 'not-allowed',
            }}
            onClick={() => chain.id !== chainId && WHITELIST_CHAIN.includes(chain.id) && switchNetwork(chain.id)}
          >
            <ChainLogo chainId={chain.id} />
            <Text color={chain.id === chainId ? 'primary' : 'text'} bold={chain.id === chainId} pl="12px">
              {chain.name}
            </Text>
            {!WHITELIST_CHAIN.includes(chain.id) && (
              <div
                style={{
                  marginLeft: 10,
                  borderRadius: 5,
                  background: 'rgba(204, 204, 204, 0.15)',
                  padding: '4px 8px',
                  color: '#AAA',
                  fontSize: 14,
                  fontWeight: 500,
                }}
              >
                {t('Coming Soon')}
              </div>
            )}
          </UserMenuItem>
        ))}
      {/* <UserMenuItem
        key={`aptos-${AptosChain.id}`}
        style={{ justifyContent: 'flex-start' }}
        as="a"
        target="_blank"
        href="https://aptos.pancakeswap.finance/swap"
      >
        <Image
          src="https://aptos.pancakeswap.finance/images/apt.png"
          width={24}
          height={24}
          unoptimized
          alt={`chain-aptos-${AptosChain.id}`}
        />{' '}
        <Text color="text" pl="12px">
          {AptosChain.name}
        </Text>
      </UserMenuItem> */}
    </>
  )
}

const LIST_ICON_CHANGE = [1975, 137]
const WrongNetworkSelect = ({ switchNetwork, chainId }) => {
  const { t } = useTranslation()
  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    t(
      'The URL you are accessing (Chain id: %chainId%) belongs to %network%; mismatching your wallet’s network. Please switch the network to continue.',
      {
        chainId,
        network: chains.find((c) => c.id === chainId)?.name ?? 'Unknown network',
      },
    ),
    {
      placement: 'auto-start',
      hideTimeout: 0,
    },
  )
  const { chain } = useNetwork()
  const localChainId = ChainId.ONUS
  const [, setSessionChainId] = useSessionChainId()

  const localChainName = chains.find((c) => c.id === localChainId)?.name ?? 'BSC'

  const [ref1, isHover] = useHover<HTMLButtonElement>()

  return (
    <>
      <Flex ref={targetRef} alignItems="center" px="16px" py="8px">
        <InfoIcon color="textSubtle" />
        <Text color="textSubtle" pl="6px">
          {t('Please switch network')}
        </Text>
      </Flex>
      {tooltipVisible && tooltip}
      <UserMenuDivider />
      {chain && (
        <UserMenuItem ref={ref1} onClick={() => setSessionChainId(chain.id)} style={{ justifyContent: 'flex-start' }}>
          <ChainLogo chainId={chain.id} />
          <Text color="primary" bold pl="12px">
            {chain.name}
          </Text>
        </UserMenuItem>
      )}
      <Box px="16px" pt="8px">
        {isHover ? <ArrowUpIcon color="text" /> : <ArrowDownIcon color="text" />}
      </Box>
      <UserMenuItem onClick={() => switchNetwork(localChainId)} style={{ justifyContent: 'flex-start' }}>
        <ChainLogo chainId={localChainId} />
        <Text pl="12px">{localChainName}</Text>
      </UserMenuItem>
      <Button mx="16px" my="8px" scale="sm" onClick={() => switchNetwork(localChainId)}>
        {t('Switch network in wallet')}
      </Button>
    </>
  )
}

export const NetworkSwitcher = () => {
  const { t } = useTranslation()
  const { chainId, isWrongNetwork, isNotMatched } = useActiveChainId()
  const { isLoading, canSwitch, switchNetworkAsync } = useSwitchNetwork()
  const router = useRouter()

  useNetworkConnectorUpdater()

  const { targetRef, tooltip, tooltipVisible } = useTooltip(
    t('Unable to switch network. Please try it on your wallet'),
    { placement: 'bottom' },
  )

  const cannotChangeNetwork = !canSwitch

  if (!chainId || router.pathname.includes('/info')) {
    return null
  }

  return (
    <Box ref={cannotChangeNetwork ? targetRef : null} height="100%">
      <Flex height="100%" alignItems="center">
        {cannotChangeNetwork && tooltipVisible && tooltip}
        <UserMenu
          placement="bottom"
          variant={isLoading ? 'pending' : isWrongNetwork || !WHITELIST_CHAIN.includes(chainId) ? 'danger' : 'default'}
          avatarSrc={
            LIST_ICON_CHANGE.includes(chainId) || !chainId
              ? `/images/${chainId}.png`
              : `${ASSET_CDN}/web/chains/${chainId}.png`
          }
          disabled={cannotChangeNetwork}
          hiddenDownIcon
        >
          {() =>
            isNotMatched || !WHITELIST_CHAIN.includes(chainId) ? (
              <WrongNetworkSelect switchNetwork={switchNetworkAsync} chainId={chainId} />
            ) : (
              <NetworkSelect switchNetwork={switchNetworkAsync} chainId={chainId} />
            )
          }
        </UserMenu>
        <Acount />
      </Flex>
    </Box>
  )
}
